var map = {
	"./title-carousel.de-CH.json": 1193,
	"./title-carousel.de-DE.json": 1194,
	"./title-carousel.en-CA.json": 1195,
	"./title-carousel.en-GB.json": 1196,
	"./title-carousel.en-IN.json": 1197,
	"./title-carousel.en-ME.json": 1198,
	"./title-carousel.en-US.json": 1199,
	"./title-carousel.es-EM.json": 1200,
	"./title-carousel.es-ES.json": 1201,
	"./title-carousel.fr-BE.json": 1202,
	"./title-carousel.fr-CA.json": 1203,
	"./title-carousel.fr-CH.json": 1204,
	"./title-carousel.nl-BE.json": 1205,
	"./title-carousel.nl-NL.json": 1206,
	"./title-carousel.pl-PL.json": 1207,
	"./title-carousel.pt-BR.json": 1208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1192;